const TimeZoneList = ({ selectedTimeZone, onChange }) => {
  // You can use hardcoded arrays or full list from Intl
  const timezones = Intl.supportedValuesOf("timeZone");

  // Divide into regions
  const regions = {
    Africa: timezones.filter((tz) => tz.startsWith("Africa/")),
    America: timezones.filter((tz) => tz.startsWith("America/")),
    Asia: timezones.filter((tz) => tz.startsWith("Asia/")),
  };

  // Function to get correct UTC offset
  const getOffset = (timeZone) => {
    const now = new Date();
    
    // Get the local time string in the target timezone
    const tzString = now.toLocaleString("en-US", { 
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });
    
    // Get the local time string in UTC
    const utcString = now.toLocaleString("en-US", { 
      timeZone: "UTC",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });
    
    // Both interpreted as local time, so the difference is the offset
    const tzDate = new Date(tzString);
    const utcDate = new Date(utcString);
    
    const offsetMinutes = (tzDate.getTime() - utcDate.getTime()) / 60000;
    const sign = offsetMinutes >= 0 ? "+" : "-";
    const absMinutes = Math.abs(offsetMinutes);
    const hours = String(Math.floor(absMinutes / 60)).padStart(2, "0");
    const minutes = String(absMinutes % 60).padStart(2, "0");
    
    return `${sign}${hours}:${minutes}`;
  };
  // Render options for a region
  // const renderRegionOptions = (regionName, tzArray) => (
  //   <>
  //     <option disabled style={{ fontWeight: "bold" }}>{regionName}</option>
  //     {tzArray.map((tz) => (
  //       <option key={tz} value={tz}>
  //         {getOffset(tz)} {tz}
  //       </option>
  //     ))}
  //   </>
  // );

  const renderRegionOptions = (regionName, tzArray) => {
    // Return an array instead of a fragment
    const options = [
      <option key={`${regionName}-header`} disabled style={{ fontWeight: "bold" }}>
        {regionName}
      </option>
    ];
    
    tzArray.forEach((tz) => {
      options.push(
        <option key={tz} value={tz}>
          {getOffset(tz)} {tz}
        </option>
      );
    });
    
    return options;
  };


  return (
    <select className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-md" value={selectedTimeZone} onChange={(e) => onChange(e.target.value)}>
      <option value="UTC">+00:00 UTC</option>
      {renderRegionOptions("Africa", regions.Africa)}
      {renderRegionOptions("America", regions.America)}
      {renderRegionOptions("Asia", regions.Asia)}
    </select>
  );
};
export default TimeZoneList;